import { RuleSet } from '../Components/Options';
import { InputType } from '../types';

export const DateTimeFormatInput: InputType = [{ value: 'new Date()', type: 'string' }];

export const DateTimeFormatRangeInput: InputType = [
	{ value: "new Date('2000-01-12'), new Date()", type: 'string' }
];

export const DatTimeFormatRuleSet: RuleSet = [
	{
		type: 'disjunction',
		set1: new Set<string>(['dateStyle', 'timeStyle']),
		set2: new Set<string>([
			'weekday',
			'era',
			'year',
			'month',
			'day',
			'hour',
			'minute',
			'second',
			'timeZoneName',
			'fractionalSecondDigits'
		])
	}
];
